import FooterLine from './FooterLine.vue'

export {
    FooterLine
}
